export enum MaterialResponsibility {
  Contractor = 'CFCI',
  Owner = 'OFCI',
}
